import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppState } from '../../../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { Observable, Subject, Subscription } from 'rxjs';
import { State } from '@clr/angular';
import { ReplicatedService } from './replicated.service';
import { HttpClient } from '@angular/common/http';
var $ = require('jquery');

@Component({
  selector: 'replicated-vdc',
  providers: [ReplicatedService, TranslateService],
  host: {'[class.content-container]': 'true'},
  styles: [require('./replicated-vdc.scss')],
  encapsulation: ViewEncapsulation.None,
  template: require('./replicated-vdc.html')
})

export class ReplicatedVdc {
  private pageSize: number = 10;

  private subscription: Subscription;
  private replicatedVdcs = [];
  private loading: boolean = true;
  private result: any;

  constructor(public appState: AppState, public translate: TranslateService, public http: HttpClient, public service: ReplicatedService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    this.getReplicatedVdcs();
  }

  refresh(state: State) {
    this.loading = true;
    this.getReplicatedVdcs();
  }

  ngOnChanges(changes) {
    this.loading = true;
    this.getReplicatedVdcs();
  }

  getReplicatedVdcs() {
    this.subscription = this.service.getReplicatedVdcs()
      .subscribe(
        result => {
          this.result = result;
          this.processData(this.result);
        },
        error => this.service.logError(error, 'get replicated Vdcs'),
        () => this.service.logOperationCompleted('get replicated Vdcs completed')
      );
  }

  processData(res) {
    if (res) {
      this.replicatedVdcs = res;
    } else {
      this.replicatedVdcs = [];
    }
    this.loading = false;
  }

  ngOnDestroy() {
    if (this.subscription) {
        this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated-vdc.component.ts